import { motion } from "framer-motion";
import { Flame, Droplets, ThermometerSun, HelpCircle } from "lucide-react";

const painPoints = [
  {
    icon: Flame,
    text: "Too spicy for a child",
    color: "#9F3E18",
  },
  {
    icon: Droplets,
    text: "Too salty for a senior",
    color: "#2E5C5A",
  },
  {
    icon: ThermometerSun,
    text: "Too bland for a spice lover",
    color: "#D97706",
  },
  {
    icon: HelpCircle,
    text: "Too uncertain for a health-conscious user",
    color: "#4A5D23",
  },
];

export const ProblemReveal = () => {
  return (
    <section data-testid="problem-reveal-section" className="relative overflow-hidden py-24 lg:py-36">
      <div className="pointer-events-none absolute inset-0">
        <img
          src={`${process.env.PUBLIC_URL}/jars.png`}
          alt=""
          className="absolute inset-0 h-full w-full object-cover object-center opacity-82"
        />
        <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(248,244,237,0.74)_0%,rgba(248,244,237,0.52)_35%,rgba(248,244,237,0.8)_100%)]" />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-cream-secondary/20 to-transparent" />
      </div>

      <div className="section-container relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="text-center max-w-3xl mx-auto mb-20"
        >
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-700 text-sw-text leading-tight">
            Because{" "}
            <span className="font-accent italic text-earth-green">one jar</span>{" "}
            never works for everyone.
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8 max-w-5xl mx-auto">
          {painPoints.map((point, index) => (
            <motion.div
              key={point.text}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
              data-testid={`pain-point-${index}`}
              className="text-center space-y-4 p-6"
            >
              <div
                className="w-14 h-14 rounded-2xl flex items-center justify-center mx-auto"
                style={{ backgroundColor: `${point.color}10` }}
              >
                <point.icon size={24} style={{ color: point.color }} />
              </div>
              <p className="text-base font-heading font-semibold text-sw-text">
                {point.text}
              </p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="text-center max-w-2xl mx-auto mt-16"
        >
          <p className="text-base lg:text-lg text-sw-text-secondary leading-relaxed">
            Some want less spice. Some need less salt. Some want full traditional heat.{" "}
            <span className="text-earth-green font-medium">
              Swadishes lets every household create food that actually fits.
            </span>
          </p>
        </motion.div>
      </div>
    </section>
  );
};
